/* eslint-disable react/prop-types */
import { makeStyles } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';

const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
    color: '#929292',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2em',
    height: '100%',
  },
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '20%',
    animation: `$fadeIn 2s ease-in-out`,
  },
  title: {
    fontSize: '2em',
    fontWeight: '600',
    color: '#000',
  },
  subtTitle: {
    fontSize: '1em',
  },
  personsBox: {
    width: '100%',
    flex: 1,
    flexWrap: 'wrap',
    display: 'flex',
    gap: '.4em',
    justifyContent: 'center',
    alignItems: 'flex-start',
    animation: `$fadeIn 2s ease-in-out`,
  },
  person: {
    outline: 'none',
    fontSize: '1em',
    color: 'inherit',
    textAlign: 'start',
    width: '15em',
    border: '1px solid #e3e3e3',
    height: 'auto',
    overflow: 'hidden',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    padding: '.4em .4em .4em .4em',
    borderRadius: '1em',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '.8em',

    transition: 'all .4s ease-in-out',

    '&:hover': {
      opacity: 0.6,
    },

    cursor: 'pointer',
  },
  personName: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.2em',
  },

  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
});

const ListPersons = ({ handleChangePerson = (id) => {}, persons = [] }) => {
  const classes = useStyles();

  const handleSelectPerson = (id) => {
    handleChangePerson(id);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.root}>
        <div className={classes.title}>Olá, sou o seu Assistente da Pessego.</div>
        <div className={classes.subtTitle}>
          <Typewriter words={['Comece selecionando um dos nossos atendentes.']} loop={1} typeSpeed={60} cursor />
        </div>
      </div>

      <div className={classes.personsBox}>
        {persons.map((person) => (
          <button
            type="button"
            className={classes.person}
            onClick={() => {
              handleSelectPerson(person?.id);
            }}>
            <div className={classes.personName}>
              <img src="favicon.png" width={24} height={24} alt="CRM LOGO" />
              {person?.name}
            </div>
            <div className={classes.personDescription}>{person?.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ListPersons;
